import createAction from "../../../actions/safeCreateAction";
// Change a specific load order entry.
export const setLoadOrderEntry = createAction("SET_LOAD_ORDER_ENTRY", (profileId, modId, loEntry) => ({
    profileId,
    modId,
    loEntry,
}));
